
import { IResponseLogin } from "@interfaces/iresponse-login";
import { assign } from "lodash";
/* tslint:disable:no-var-requires */
const CryptoJS = require("crypto-js");
const cookie = require('react-cookies');


export const getCookie = (cookieName: any, str: any) => {
    try {
        if (cookie.load(cookieName) !== undefined) {
            const bytes = CryptoJS.AES.decrypt(
                cookie.load(cookieName),
                `${process.env.REACT_APP_SECRET_ENCRYPTER}`
            );
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return decryptedData[str];
        }
        return null;
    } catch (error) {
        return null;
    }

};

export const setCookie = (cookieName: any, objCookies: any) => {
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(objCookies),
        `${process.env.REACT_APP_SECRET_ENCRYPTER}`
    );

    cookie.save(cookieName, ciphertext.toString(), { path: "/" });

    return cookie;
};

export const clearCookie = (cookieName: any) =>
    cookie.remove(cookieName, { path: "/" });

export const setSessionLogin = async (resp: IResponseLogin) => {
    const data = resp;
    const { accessToken, expiresIn, refreshToken } = data;

    const authCookies = assign({
        [`${process.env.REACT_APP_PROJECT}_isLoggedIn`]: true,
        [`${process.env.REACT_APP_PROJECT}_accessToken`]: accessToken,
        [`${process.env.REACT_APP_PROJECT}_expired`]: expiresIn,
        [`${process.env.REACT_APP_PROJECT}_refreshToken`]: refreshToken
    });

    setCookie("auth", authCookies);
};

export const getToken = () => getCookie(
    "auth",
    `${process.env.REACT_APP_PROJECT}_accessToken`
);

export const getRefreshToken = () => getCookie(
    "auth",
    `${process.env.REACT_APP_PROJECT}_refreshToken`
);

export const getFcmToken = () => getCookie(
    "fcm",
    `${process.env.REACT_APP_PROJECT}_fcmToken`
);

export const setFcmInfo = (token: any) => {

    const fcmToken = assign({
        [`${process.env.REACT_APP_PROJECT}_fcmToken`]: token,
    });

    setCookie("fcm", fcmToken);
};

export const clearAllCookie = () => {
    clearCookie("auth");
    clearCookie("profileCookies");
    localStorage.clear();
}

export const isLogin = () => getCookie('auth', `${process.env.REACT_APP_PROJECT}_isLoggedIn`);


// WEBPACK FOOTER //
// ./src/helpers/cookies.tsx